import { getNumericBalance, loadAutoWithdrawConfig } from "./autoWithdraw";

export const buildGameStartPayload = ({ data, playerBalance }) => {
  const userId = data?.id;
  const autoWithdrawConfig = loadAutoWithdrawConfig(userId);

  return {
    ...data,
    autoWithdraw: {
      enabled: Boolean(autoWithdrawConfig?.enabled),
      threshold: Math.max(0, Number(autoWithdrawConfig?.threshold || 0)),
      currentBalance: getNumericBalance(playerBalance),
    },
  };
};
